import React from "react";
import axios from "axios";
import "./styles.scss";
import {
  Label,
  Container,
  Col,
  Form,
  Card,
  CardHeader,
  CardBody,
  Button,
} from "reactstrap";
import { Services } from "../../../repositories/clients/Services";
import LogoLogin from "./../../../resources/logo_login.png";
import { message } from "antd";
import { Input } from "semantic-ui-react";
import { withNamespaces } from "react-i18next";
import loginOBL from "./../../../resources/OBL-backgr.webp";
import styled from "styled-components";

const BackgroundContainer = styled.div`
  flex: 1 1 0%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-image: url(${loginOBL});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-left: 5%;

  @media (max-width: 768px) {
    display: none;
  }
`;
/*=============================================
=            Login Component                  =
=============================================*/
function Recover(props) {
  const [redirectlogin, setRedirectlogin] = React.useState({
    login: {
      newcontrasena: "",
      valid: false,
      confirmarcontrasena: "",
      check: false,
      email: "",
    },
  });
  let [Mostrar, setMostrar] = React.useState(false);
  let [exito] = React.useState(false);
  let [TokenValido, setTokenValido] = React.useState(true);

  const getAutentication = React.useCallback(() => {
    axios
      .get(
        `${Services.ADMIN.path}admin/recovery?token=${props.match.params.token}`,
        {},
      )
      .then((response) => {
        redirectlogin.login.email = response.data.email;
        setRedirectlogin({ redirectlogin, ...redirectlogin });
        setTokenValido(true);
      })
      .catch((error) => {
        setTokenValido(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.token]);

  React.useEffect(() => {
    getAutentication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function validatePasswords(newPassword, confirmPassword) {
    if (newPassword === confirmPassword) {
      document
        .getElementById("pass_diferentes")
        .setAttribute("hidden", "hidden");
      document.getElementById("se_cumple").removeAttribute("hidden");
      document.getElementById("input_correo").className = "input100";
    } else {
      document.getElementById("pass_diferentes").removeAttribute("hidden");
      document.getElementById("input_correo").className = "invalidInput";
      document.getElementById("se_cumple").setAttribute("hidden", "hidden");
    }
  }

  function change(event) {
    document.getElementById("email_sin").setAttribute("hidden", "hidden");
    document.getElementById("pass_sin").setAttribute("hidden", "hidden");

    let value = event.target.value;
    redirectlogin.login[event.target.name] = value;
    setRedirectlogin({ redirectlogin, ...redirectlogin });

    if (
      event.target.name === "newcontrasena" ||
      event.target.name === "confirmarcontrasena"
    ) {
      const newPassword = redirectlogin.login.newcontrasena;
      const confirmPassword = redirectlogin.login.confirmarcontrasena;
      validatePasswords(newPassword, confirmPassword);
    }

    if (event.target.name === "newcontrasena") {
      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/,
      );
      if (emailRegex.test(value)) {
        document.getElementById("input_email").className = "input100";
        document.getElementById("123456").setAttribute("hidden", "hidden");
      } else {
        document.getElementById("input_email").className = "invalidInput";
        document.getElementById("123456").removeAttribute("hidden");
      }
    }
  }

  function handleLoginId() {
    if (!redirectlogin.login.newcontrasena) {
      document.getElementById("email_sin").removeAttribute("hidden");
    } else if (!redirectlogin.login.confirmarcontrasena) {
      document.getElementById("pass_sin").removeAttribute("hidden");
    } else {
      document.getElementById("email_sin").setAttribute("hidden", "hidden");
      document.getElementById("pass_sin").setAttribute("hidden", "hidden");
      let data = {
        email: redirectlogin.login.email,
        password: redirectlogin.login.newcontrasena,
      };

      axios
        .put(`${Services.ADMIN.path}admin/changePass`, data)
        .then((response) => {
          // document.getElementById("pass_changue").removeAttribute("hidden");
          sendMessage(props.t("pass_change_succesful"), "success");
          setTimeout(() => {
            props.history.push("/");
          }, 1500);
          //setexito(true);
        })
        .catch((error) => {
          sendMessage(props.t("error_token"), "error");
        });
    }
  }

  function sendMessage(text, type) {
    var messageClass = "";
    if (type === "error") {
      messageClass =
        "general-custom-ant-message error-blue-ant-message  ant-centered";
    } else if (type === "success") {
      messageClass =
        "general-custom-ant-message success-custom-ant-message ant-centered";
    } else if (type === "info") {
      messageClass = "info-custom-ant-message";
    }
    message.open({
      content: text,
      className: messageClass,
    });
  }
  React.useEffect(() => {
    // i18n.changeLanguage(navLang.split("-")[0] == "es" ? "ES" : "EN")
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <BackgroundContainer>
        <div
          style={{
            height: "40%", // Ocupa el 40% del alto del div principal
            display: "flex",
            alignItems: "center",
            textAlign: "left",
            fontSize: "clamp(1.5rem, 2.5vw, 2.5rem)", // Tamaño responsivo
            lineHeight: "1.3",
            maxWidth: "600px", // Limita el ancho para mejor lectura
          }}
        >
          <span className="custom-font-span">
            ADVANCED{" "}
            <strong>
              DIGITAL <br /> EXPERIENCE ON <br /> END-TO-END <br />
            </strong>{" "}
            VISIBILITY
          </span>
        </div>
      </BackgroundContainer>
      <div className="login-page ">
        <Container>
          {TokenValido ? (
            <div className="">
              {exito ? (
                <Container>
                  <Card className="loginContainer">
                    <CardBody>
                      <label
                        style={{
                          color: "#fff",
                          fontSize: "22px",
                          marginBottom: "2em",
                        }}
                      >
                        {props.t("pass_change_successfully")}
                      </label>{" "}
                      <div className="col-12 divcenter">
                        <div className="col-3">
                          <Button
                            id="loginGo"
                            block
                            style={{ marginBottom: "1em" }}
                            className="login100-form-btn-blue"
                            // style={{ fontWeight: 'bold', background: '#FF0000' }}
                            // color='danger'
                            onClick={() => props.history.push("/")}
                            // disabled={loading}
                          >
                            <strong>{props.t("go_portal")}</strong>
                          </Button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Container>
              ) : (
                <>
                  <Col>
                    <Form>
                      <Card className="loginContainer">
                        <CardHeader>
                          <div
                            style={{ width: "100%" }}
                            className="logo-container"
                          >
                            <img
                              style={{ marginTop: "1em" }}
                              src={LogoLogin}
                              alt="now-logo"
                            />
                          </div>
                        </CardHeader>
                        {/* <div className="logo-container2">
                            <span className={"tex_1"}>{props.t("your_shipments")}</span>{" "}
                            <span className={"tex_2"}>{props.t("always_close")}.</span>
                          </div> */}
                        <CardBody style={{ marginTop: "-4em" }}>
                          <Col xs={11} className="mr-auto ml-auto textInitial">
                            <label style={{ color: "#000", fontSize: "24px" }}>
                              {props.t("recover_pass")}
                            </label>
                            <label style={{ fontSize: "11px" }}>
                              {props.t("pass_structure")}
                            </label>
                            <label style={{ fontSize: "11px" }}>
                              * {props.t("rule_digits")}
                            </label>
                            <label style={{ fontSize: "11px" }}>
                              * {props.t("rule_uppercase")}
                            </label>
                            <label style={{ fontSize: "11px" }}>
                              * {props.t("rule_special_char")}.
                            </label>
                          </Col>
                          <br />
                          {/* Inputs */}
                          <Col xs={11} className="mr-auto ml-auto">
                            <Input
                              fluid
                              // className="input100"
                              id="input_email"
                              type={Mostrar ? "text" : "password"}
                              value={redirectlogin.login.newcontrasena}
                              name="newcontrasena"
                              onChange={change}
                              placeholder={props.t("new_pass")}
                            />
                          </Col>
                          <span className="focus-input100"></span>
                          <br />
                          <Col xs={11} className="mr-auto ml-auto">
                            <Input
                              fluid
                              id="input_correo"
                              // className="input100"
                              type={Mostrar ? "text" : "password"}
                              value={redirectlogin.login.confirmarcontrasena}
                              name="confirmarcontrasena"
                              onChange={change}
                              placeholder={props.t("confirm_pass")}
                            />
                          </Col>
                          <span className="focus-input100"></span>

                          <div
                            style={{
                              padding: "3px",
                              // marginTop: "-14px",
                              color: "#FF0000",
                              fontSize: "12px",
                            }}
                            className="_alert"
                            id="email_sin"
                            hidden
                          >
                            {props.t("pass_required")}
                          </div>
                          <div
                            style={{
                              padding: "3px",
                              // marginTop: "-14px",
                              color: "#FF0000",
                              fontSize: "12px",
                            }}
                            className="_alert"
                            id="pass_sin"
                            hidden
                          >
                            {props.t("confirm_pass")}
                          </div>
                          <div
                            style={{
                              padding: "3px",
                              // marginTop: "-14px",
                              color: "#FF0000",
                              fontSize: "12px",
                            }}
                            className="_alert"
                            id="pass_diferentes"
                            hidden
                          >
                            {props.t("pass_must_same")}
                          </div>
                          <div
                            style={{
                              padding: "3px",
                              // marginTop: "-14px",
                              color: "#FF0000",
                              fontSize: "12px",
                            }}
                            className="_alert"
                            id="pass_changue"
                            hidden
                          >
                            {props.t("pass_change_succesful")}
                          </div>
                          <div
                            style={{
                              padding: "3px",
                              // marginTop: "-14px",
                              color: "#FF0000",
                              fontSize: "12px",
                            }}
                            className="_alert"
                            id="123456"
                            hidden
                          >
                            {props.t("invalid_pass")}
                          </div>

                          <br />
                          <Col
                            style={{ textAlign: "initial" }}
                            xs={11}
                            className="mr-auto ml-auto"
                          >
                            <Label>
                              <Input
                                type="checkbox"
                                style={{
                                  marginRight: "8px",
                                  color: "#fff",
                                }}
                                onChange={() => {
                                  setMostrar(!Mostrar);
                                }}
                                checked={Mostrar}
                              />
                              <spam>{props.t("show")}</spam>
                            </Label>
                          </Col>
                          <br />

                          {/* Buttom */}
                          <div className="col-12 divcenter">
                            <div className="col-6">
                              <Button
                                id="se_cumple"
                                block
                                style={{ marginBottom: "1em" }}
                                hidden
                                color="primary"
                                // style={{ fontWeight: 'bold', background: '#FF0000' }}
                                // color='danger'
                                onClick={handleLoginId}
                                // disabled={loading}
                              >
                                <strong>{props.t("change")}</strong>
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Form>
                  </Col>
                </>
              )}
            </div>
          ) : (
            <Container>
              <Card className="loginContainer">
                <CardHeader>
                  <center>
                    <div className="logo-container2">
                      <img src={LogoLogin} alt="now-logo" />
                    </div>
                    <div className="logo-container2">
                      <span className={"tex_1"}>
                        {props.t("your_shipments")}
                      </span>{" "}
                      <span className={"tex_2"}>
                        {props.t("always_close")}.
                      </span>
                    </div>
                  </center>
                </CardHeader>
                <CardBody>
                  <div style={{ height: "1em" }} className="col-12"></div>
                  <div className="col-12"></div>
                  <div style={{ height: "1em" }} className="col-12"></div>
                  <label style={{ fontSize: "20px" }}>
                    Error: {props.t("error_token")}
                  </label>
                  <div style={{ height: "1em" }} className="col-12"></div>
                </CardBody>
              </Card>
            </Container>
          )}
        </Container>
      </div>
    </div>
  );
}
// export default withRouter(Recover);
export default withNamespaces()(Recover);
